import { render, staticRenderFns } from "./Insert.vue?vue&type=template&id=86989916&scoped=true"
import script from "./Insert.vue?vue&type=script&lang=js"
export * from "./Insert.vue?vue&type=script&lang=js"
import style0 from "./Insert.vue?vue&type=style&index=0&id=86989916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86989916",
  null
  
)

export default component.exports